export enum TradeType {
  BUY = 'BUY',
  SELL = 'SELL'
}

export enum TradeBase {
  SOL = 'SOL',
  TOKEN = 'TOKEN'
}

export enum SupportValue {
  Max = 'Max',
  Reset = 0
}

export const Decimal = {
  Default: 6,
  SOL: 9,
  BET: 6,
  veToken: 6
}

export enum Address {
  BET = '4cVem78bCJnk5snZCQvLV2kF7SPqzmwzDKoBQ8tZHVTZ'
}
